"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _IconElement = _interopRequireDefault(require("../IconElement"));

var ContactElement =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(ContactElement, _React$Component);

  function ContactElement() {
    (0, _classCallCheck2["default"])(this, ContactElement);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ContactElement).apply(this, arguments));
  }

  (0, _createClass2["default"])(ContactElement, [{
    key: "renderLink",
    value: function renderLink() {
      var _this$props = this.props,
          contact = _this$props.contact,
          link = _this$props.link,
          iconType = _this$props.iconType,
          as = _this$props.as,
          iconPosition = _this$props.iconPosition,
          buttonColor = _this$props.buttonColor,
          fluidButton = _this$props.fluidButton,
          buttonSize = _this$props.buttonSize; // Button use case

      var iconProps = iconType === 'none' ? {} : {
        icon: iconType
      };
      var contentProps = as === 'icon' ? {} : {
        content: contact
      };
      var isPrimary = buttonColor === 'primary';
      var buttonColorProps = isPrimary ? {
        primary: true
      } : {
        secondary: true
      };

      if (as === 'text') {
        var header = _react["default"].createElement("a", {
          href: link
        }, _react["default"].createElement("p", null, contact));

        return iconType === 'none' || iconType === '' ? header : _react["default"].createElement(_IconElement["default"], {
          iconType: iconType,
          element: header,
          iconPosition: iconPosition
        });
      }

      return _react["default"].createElement(_semanticUiReact.Button, (0, _extends2["default"])({
        fluid: fluidButton,
        size: buttonSize,
        as: "a",
        href: link
      }, buttonColorProps, contentProps, iconProps));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var header = this.props.header;
      return _react["default"].createElement(_semanticUiReact.Header, {
        as: "h2"
      }, header);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          header = _this$props2.header;
      return header !== '' ? _react["default"].createElement("div", {
        className: className
      }, this.renderHeader(), this.renderLink()) : this.renderLink();
    }
  }]);
  return ContactElement;
}(_react["default"].Component);

exports["default"] = ContactElement;
ContactElement.propTypes = {
  contact: _propTypes["default"].string.isRequired,
  link: _propTypes["default"].string.isRequired,
  as: _propTypes["default"].oneOf(['text', 'button', 'icon']),
  buttonColor: _propTypes["default"].string,
  buttonSize: _propTypes["default"].string,
  className: _propTypes["default"].string,
  fluidButton: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  iconPosition: _propTypes["default"].string,
  iconType: _propTypes["default"].string
};
ContactElement.defaultProps = {
  as: 'text',
  buttonColor: 'primary',
  buttonSize: 'large',
  className: '',
  fluidButton: false,
  header: '',
  iconPosition: 'left',
  iconType: 'mail'
};